import './App.css';
import FinanceApp from "./FinanceApp";

function App() {
  return (
    <div className="App">
      <FinanceApp></FinanceApp>
    </div>
  );
}

export default App;
